<template>
  <div id="editGamepass">
    <div class="thead">Выбор gamepass</div>
    <div class="wa">Измените цену данного <a :href="url" target="_blank">gamepass</a> на <span @click="copyAmount" class="amount">{{ change }}</span></div>
	<div class="wa" v-if="data.dupe !== null">Мы купим его {{ data.dupe }} раз{{ [2, 3, 4].indexOf(data.dupe % 10) !== -1 ? "а" : "" }}.</div>
	<div class="df fr wa">
	  <button class="wa green" @click="$root.startBuildingOrderDo({ ...data, gamepassesIds: [data.id] })" >Выполнил</button>
	  <button class="wa red" @click="$root.setState({ label: 'buy-one' })">Назад</button>
	</div>
  </div>
</template>

<script>
import Utils from "@/utils.js"
export default {
  props: ["data"],

  computed: {
	change() {
	  return this.data.amount ? Utils.recommision(this.data.amount) : null
	},
	url() {
	  return `https://create.roblox.com/dashboard/creations/experiences/${this.data.universe}/passes/${this.data.id}/sales`
	}
  },

  methods: {
    copyAmount() {
      navigator.clipboard.writeText(this.change)
    }
  }
}
</script>

<style scoped lang="scss">
#editGamepass {
  width: 500px;
}
</style>
